export default function supabase({ libSupabase }) {
	return libSupabase.createClient(process.env.SB_URL, process.env.SB_ANON_KEY, { autoRefreshToken: true });
}
